import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';


import OfferResaleModal from '../offer-resale-modal';
import './offer-resale-table-tr-style.css';


function OfferResaleTableTr(props) {
    const {index, item, dictionary, width, projectData, stringProcessingService, displayedAdditional} = props;
    const [isVisibleResaleModal, setIsVisibleResaleModal] = useState(false);

    const rowVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0 }
    };

    const isNewGroup = index === 0 || item.BedroomsTotal !== displayedAdditional[index - 1].BedroomsTotal;
    const bedroomCount = Number(item.BedroomsTotal);
    const groupLabel = bedroomCount === 0
        ? dictionary.studio.charAt(0).toUpperCase() + dictionary.studio.slice(1)
        : bedroomCount === 1
            ? '1-'+ dictionary.bedroom.charAt(0).toUpperCase() + dictionary.bedroom.slice(1)
            : `${bedroomCount}-`+dictionary.bedrooms.charAt(0).toUpperCase() + dictionary.bedrooms.slice(1);

    return (
        <>


            <React.Fragment key={item.id}>
                {isNewGroup && (
                    <motion.tr
                        className='BedroomGroupHeader'
                        initial="hidden"
                        animate="visible"
                        variants={rowVariants}
                        transition={{ duration: 0.22 }}
                    >
                        <td colSpan="6"><strong>{groupLabel}</strong></td>
                    </motion.tr>
                )}
                <motion.tr
                    initial="hidden"
                    animate="visible"
                    className='OfferResaleTableTr'
                    variants={rowVariants}
                    transition={{ duration: 0.22 }}
                >
                    <td style={{ textAlign: 'left' }}> <span className='UnitNumber' onClick={() => setIsVisibleResaleModal(true)} >{item.UnitNumber}</span></td>
                    <td style={{ textAlign: 'right' }}>{item.BathroomsTotalDecimal}</td>
                    <td style={{ textAlign: 'right' }}>{stringProcessingService.convertToFormat(item.LivingArea ? item.LivingArea.toString() : '')}</td>
                    <td style={{ textAlign: 'right' }}>${stringProcessingService.convertToFormat(item.ListPrice.toString())}</td>
                    <td style={{ textAlign: 'right' }}>{stringProcessingService.convertToFormat(item.LivingArea && item.LivingArea > 0 ? '$' + (item.ListPrice / item.LivingArea).toFixed(0) : '')}</td>
                    <td style={{ textAlign: 'center' }}>
                        <div className='Button' id='DetailsButton' onClick={() => setIsVisibleResaleModal(true)}>{dictionary.details.toUpperCase()}</div>
                        <OfferResaleModal
                            data={item}
                            dictionary={dictionary}
                            width={width}
                            projectData={projectData}
                            isVisible={isVisibleResaleModal}
                            setIsVisible={setIsVisibleResaleModal}
                        />
                    </td>
                    
                </motion.tr>
            </React.Fragment>

            
        </>
    )
}

export default OfferResaleTableTr;